import { inventoryService } from '@services/index';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useMutationDeleteInventory() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (inventoryId: number) => inventoryService.deleteInventory(inventoryId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['Inventory'] });
		}
	});
}
